import { Component, Input } from '@angular/core';

@Component({ standalone: false, 
  selector: 'cyborg-progress-bar',
  templateUrl: './cyborg-progress-bar.component.html',
  styleUrls: ['./cyborg-progress-bar.component.scss'],
})
export class CyborgProgressBarComponent {
  @Input() public value: number = 0; // Default value, accepts values from 0 to 100
}
